<script lang="ts" setup>
const props = defineProps<{
  websiteUrl?: string | null;
  linkedInName?: string | null;
  twitterName?: string | null;
  youTubeChannelId?: string | null;
  org?: boolean;
  showPlatformNames?: boolean;
}>();

const linkedInUrl = computed( () => {
  let result = null;

  if ( props.linkedInName ) {
    let prefix = "https://www.linkedin.com/";

    if ( props.org ) {
      prefix += "company/";
    }

    const name = props.linkedInName.replace( prefix, "" );
    result = `${prefix}${name}`;
  }

  return result;
} );

const twitterUrl = computed( () => {
  let result = null;

  if ( props.twitterName ) {
    const prefix = "https://twitter.com/";
    const name = props.twitterName.replace( prefix, "" );
    result = `${prefix}${name}`;
  }

  return result;
} );

const youTubeUrl = computed( () => {
  let result = null;

  if ( props.youTubeChannelId ) {
    const prefix = "https://youtube.com/channel/";
    const name = props.youTubeChannelId.replace( prefix, "" );
    result = `${prefix}${name}`;
  }

  return result;
} );
</script>

<template>
  <div class="links-list">
    <div
      v-if="websiteUrl"
      class="links-list__social-link">
      <div class="links-list__social-icon">
        <a-icon
          icon="fa:light:globe"
          role="presentation" />
        <span class="sr-only">Website</span>
      </div>
      <div>
        <a
          :href="websiteUrl"
          target="_blank"
          rel="noopener"
          class="links-list__link"
          :aria-label="`Visit website: ${websiteUrl} (opens in new tab)`">
          {{ websiteUrl }}
        </a>
      </div>
    </div>

    <a
      :href="linkedInUrl"
      target="_blank"
      rel="noopener"
      aria-label="Visit LinkedIn profile (opens in new tab)"><div
        v-if="linkedInName && linkedInUrl"
        class="links-list__social-link">
        <div class="links-list__social-icon">
          <a-icon
            icon="fa:brands:linkedin-in"
            role="presentation" />
          <span
            v-if="!showPlatformNames"
            class="sr-only">LinkedIn</span>
        </div>
        <div>
          <a
            :href="linkedInUrl"
            target="_blank"
            rel="noopener"
            class="links-list__link"
            :aria-label="`LinkedIn profile: ${linkedInUrl} (opens in new tab)`">
            <template v-if="!showPlatformNames">
              {{ linkedInUrl }}
            </template>
            <template v-else />
          </a>
        </div>
      </div></a>
    <a
      :href="twitterUrl"
      target="_blank"
      rel="noopener"
      aria-label="Visit Twitter profile (opens in new tab)"><div
        v-if="twitterName && twitterUrl"
        class="links-list__social-link">
        <div class="links-list__social-icon">
          <a-icon
            icon="fa:brands:x-twitter"
            role="presentation" />
          <span
            v-if="!showPlatformNames"
            class="sr-only">Twitter</span>
        </div>
        <div>
          <a
            :href="twitterUrl"
            target="_blank"
            rel="noopener"
            class="links-list__link"
            :aria-label="`Twitter profile: ${twitterUrl} (opens in new tab)`">
            <template v-if="!showPlatformNames">
              {{ twitterUrl }}
            </template>
            <template v-else />
          </a>
        </div>
      </div></a>
    <!-- <div
      v-if="youTubeChannelId && youTubeUrl"
      class="links-list__social-link">
      <dt class="links-list__social-icon">
        <a-icon
          icon="fa:brands:youtube"
          role="presentation" />
        <span
          v-if="!showPlatformNames"
          class="sr-only">YouTube</span>
      </dt>
    </div> -->
    <!-- <div>
      <a
        :href="youTubeUrl"
        target="_blank"
        rel="noopener"
        class="links-list__link">
        <template v-if="!showPlatformNames">
          {{ youTubeUrl }}
        </template>
        <template v-else>
          YouTube
        </template>
      </a>
    </div> -->
  </div>
</template>

<style lang="scss" scoped>
.links-list {
  display: flex;
  &__social-link {
    // display: flex;
    margin-bottom: 0;
  }

  &__link {
    word-break: break-all;
  }

  &__social-icon {
    color: fff;
    display: inline-block;
    margin-right: 30px;
    background-color: #62BBAD;
    width: 70px;
    height: 70px;
    text-align: center;
    border-radius: 50px;
    font-size: 2rem;
    padding-top: 8px;
  }

  &__social-link dd {
    display: none;
  }
}
</style>
